import { css } from "@emotion/react";
import { bpoints } from "../../Utils";

export function noticePrivacyCSS() {
    return css`

    ul li{
        /* display: flex; */
        justify-content: space-between;
        margin-rigth: 1rem;        
    }display

    .ContainerExplorer{
        display: flex;
    }
    .ListExplorer li{
        width: max-content;
    }

    .ListaUrl li{
        margin: .5rem;
        a {
            color: black;
            text-decoration: underline;
            font-weight: 500;
        }
    }

    .ContainerTerms{
        margin-top: 2rem;   
    }

    /* .ContainerExplorer ul
    {
        width: max-content;
    } */

        width: 100%;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;

        .ContainerNoticePrivacy{
            display: flex;
            flex-direction: column;
            width: 70%;
            margin: 1rem 0;

            h1 {
                text-align: center;
                margin-bottom: 0.5rem;
                font-size: calc(1.3rem + 0.4vw);
            }
            h4 {
                font-size: calc(1rem + 0.2vw);
                /* text-align: center; */
            }

            p {
                //texto justificado
                text-align: justify;
                margin: 0.5rem;
                font-size: calc(0.9rem + 0.2vw)

            }

            a {
                font-weight: bold;
                color: inherit;
                text-decoration: none;
                cursor: pointer;
            }

            @media (max-width: ${bpoints.mobile.w}px){
                margin-top: 2rem;
                width: 80%;
            }
        }
        
    `;

}


